const baseOrder = {
  'baseOrder.orderStatus': 'حالة الطلب',
  'baseOrder.orderStatus.placeholder': 'الرجاء اختيار حالة الطلب',
  'baseOrder.orderStatus.toBeConfirmed': 'قيد التأكيد',
  'baseOrder.orderStatus.confirmed': 'تم التأكيد',
  'baseOrder.orderStatus.toBeShipped': 'قيد الشحن',
  'baseOrder.orderStatus.partiallyShipped': 'شحن جزئي',
  'baseOrder.orderStatus.completed': 'مكتمل',
  'baseOrder.orderStatus.cancelled': 'ملغى',

  'baseOrder.shipmentStatus': 'حالة الشحن',
  'baseOrder.shipmentStatus.placeholder': 'الرجاء اختيار حالة الشحن',
  'baseOrder.shipmentStatus.notShipped': 'لم يتم الشحن',
  'baseOrder.shipmentStatus.partiallyShipped': 'شحن جزئي',
  'baseOrder.shipmentStatus.shipped': 'تم الشحن',
  'baseOrder.shipmentStatus.abnormalShipping': 'شحن غير طبيعي',

  'baseOrder.paymentStatus': 'حالة الدفع',
  'baseOrder.paymentStatus.placeholder': 'الرجاء اختيار حالة الدفع',
  'baseOrder.paymentStatus.unpaid': 'لم يتم الدفع',
  'baseOrder.paymentStatus.partiallyPaid': 'دفع جزئي',
  'baseOrder.paymentStatus.paid': 'تم الدفع',
  'baseOrder.paymentStatus.paymentException': 'خطأ في الدفع',

  'baseOrder.orderNumber': 'رقم الطلب',
  'baseOrder.orderNumber.placeholder': 'الرجاء إدخال رقم الطلب',
  'baseOrder.orderTime': 'وقت الطلب',

  'baseOrder.customerName': 'اسم العميل',
  'baseOrder.skuTotal': 'إجمالي SKU',
  'baseOrder.totalAmount': 'مبلغ البضاعة',
  'baseOrder.fee': 'الرسوم',
};

export default baseOrder;
